import { render, staticRenderFns } from "./PendingLeads.vue?vue&type=template&id=68dade94&"
import script from "./PendingLeads.vue?vue&type=script&lang=js&"
export * from "./PendingLeads.vue?vue&type=script&lang=js&"
import style0 from "./PendingLeads.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports